// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__1vsTw","content":"default_content__P25EH","list":"default_list__l+Xzv","controls":"default_controls__dIQuW"};